import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ImageButton } from '@components//imagebutton';
import { CloseIcon } from '@components/closeicon';

import { CONFIGURE_SEARCH } from '@navigation/constants';

import { useVehicleSearchParams } from '@hooks/usevehiclesearchparams';

import Typography from '@components/typography';

import '@styles/customise/headerbanner.scss';
import useToggleLiveChat from '@hooks/usetogglelivechat';

interface CustomiseBannerProps {
  make: string;
  model: string;
}

export const HeaderBanner: React.FC<CustomiseBannerProps> = ({
  make,
  model,
}) => {
  const vehicleText = `${make} ${model}`;
  const headerText = 'Customise Your Vehicle';

  const { vehicleSearchParams } = useVehicleSearchParams();
  const { showElement } = useToggleLiveChat();

  let navigate = useNavigate();
  const handleClose = () => {
    navigate(CONFIGURE_SEARCH(vehicleSearchParams));
    showElement();
  };

  return (
    <section
      className="customise-banner wide-component-container"
      data-testid="header-banner"
      data-cy="customise-banner"
    >
      <div className="customise-banner__text">
        <Typography size={'sm'} colour={'primary'} variant={'button'}>
          {vehicleText}
        </Typography>
      </div>
      <div className="customise-banner__label">
        <Typography size={'2x'} colour={'primary'} variant={'h1'}>
          {headerText}
        </Typography>
      </div>
      <div className="customise-banner__close">
        <div className="configure-header__link">
          <ImageButton
            variant="text"
            ButtonIcon={CloseIcon}
            onClick={handleClose}
            size={'small'}
            ariaLabel="Close"
          >
            Close
          </ImageButton>
        </div>
      </div>
    </section>
  );
};
